'use strict';

class Dashboard {
  constructor(originatorService) {
    this.originatorService = originatorService;
  }

  $onInit() {
    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
      });
  }
}

Dashboard.$inject = ['originatorService'];

const dashboard = {
  controller: Dashboard,
  template: `
    <h2>Oversikt</h2>

    <a ng-show="$ctrl.originator && $ctrl.originator.giroLayout" role="button" class="button" href="#/regning/kladd/ny">Send regning</a>
    <a ng-show="$ctrl.originator && !$ctrl.originator.giroLayout" role="button" class="button" href="#/regning/kladd/utengiro/ny">Send regning</a>

    <a role="button" class="button" href="#/fast-oppdrag/kladd">Nytt fast oppdrag</a>
    <a role="button" class="button" href="#/tilbud/kladd/ny">Send tilbud</a>
    <a role="button" class="button" href="#/ordrebekreftelse/kladd/ny">Send ordrebekreftelse</a>
    <br>
    <a role="button" class="button secondary" href="#/kunde">Registrer ny kunde</a>
    <a role="button" class="button secondary" href="#/produkt/nytt">Opprett nytt produkt</a>

    <div class="center-align video-container">
      <iframe width="560" height="315" src="//www.youtube.com/embed/IdfszVdQ71g" frameborder="0" allowfullscreen></iframe>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('dashboard', dashboard)
  .config(($routeProvider) => {
    $routeProvider
      .when('/', {
        title: 'Oversikt',
        template: '<dashboard />',
        secure: true
      });
  });
